export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11587.2b4c4921.jpg";